const mutations = {
  getExtraPackagings: (state, extra_packaging) => {
    state.extra_packaging = extra_packaging;
  },
  getExtraPackaging: (state, extra_packaging_id) => {
    state.extra_packaging_id = extra_packaging_id;
  },
  getSlideScreen: (state, slide_screen) => {
    state.slide_screen = slide_screen;
  },
  postExtraPackaging: (state, new_extra_packaging) => {
    state.extra_packaging.push(new_extra_packaging);
  },
  updateExtraPackagings: (state, new_status) => {
    state.extra_packaging = state.extra_packaging.map((extra_packaging) => {
      if (extra_packaging.id === new_status.extra_packaging_id) {
        return Object.assign({}, extra_packaging, new_status.status);
      }
      return extra_packaging;
    });
  },
  putExtraPackaging: (state, payload) => {
    state.extra_packaging = state.extra_packaging.map((extra_packaging) => {
      if (extra_packaging.extra_packaging_id === payload.id) {
        return Object.assign({}, extra_packaging, payload.formData);
      }
      return extra_packaging;
    });
  },
  delExtraPackaging(state, id) {
    const index = state.extra_packaging.findIndex(extra_packaging => extra_packaging.extra_packaging_id == id);
    state.extra_packaging.splice(index, 1);
  },
};

export default mutations;
